import { Player } from '@lottiefiles/react-lottie-player';
import { Check, Close, DeveloperMode, LinkedIn, Person, School, TaskAlt, ThumbUp, Work } from '@mui/icons-material';
import { List, ListItem, Stack, useMediaQuery, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Container } from '@mui/system';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import hiringAnimation from "../../assets/hiring.json";
import { pages } from '../../consts/types/pages';
import AppBarComp from '../AppBarComp';


interface EmployerIntroProps {

}

type Props = EmployerIntroProps;


const EmployerIntro: FC<Props> = (props: Props) => {
    const navigate = useNavigate();
    const theme = useTheme();
    const isUpMD = useMediaQuery(theme.breakpoints.up('md'));

    return <Box >
        <AppBarComp />
        <Box pt={4} pb={8} display={{ xs: "none", md: "block", background: "white" }}>
            <Container maxWidth="xl" >
                <Box display="flex">
                    <Box display="flex" flexDirection="column" justifyContent="center" flex={1} pl={4}>
                        <Typography align="left" width={"100%"} fontWeight={700} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.5rem" }} mb={3}>
                            Recruit smarter and faster.
                        </Typography>

                        <Box sx={{ display: "flex",  width: "100%",  }} mb={3}>
                            <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="greenyellow">
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>We offer a</Typography>
                            </Box>
                            <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="greenyellow">
                                <Check color='inherit' />
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Smart</Typography>
                            </Box>
                            <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="#46edffff">
                                <Check color='inherit' />
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Easy</Typography>
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center" }} color="orange">
                                <Check color='inherit' />
                                <Typography fontSize={{ xs: "1.2rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Time Saving</Typography>
                            </Box>

                        </Box>
                        <Typography align="left" width={"100%"} fontWeight={400} fontSize={{ xs: "1.2rem", md: "1.5rem" }} mb={1}>
                            platform designed to <strong>match</strong> Hig Tech job seekers and employers
                        </Typography>
                        <Typography align="left" width={"100%"} fontWeight={400} fontSize={{ xs: "1.2rem", md: "1.5rem" }} mb={1}>
                            based on details that are collected from both parties
                        </Typography>
                        <Typography align="left" width={"100%"} fontWeight={400} fontSize={{ xs: "1.2rem", md: "1.5rem" }} >
                            in order to make the most reliable and <strong>accurate</strong> match.
                        </Typography>
                        <Box mt={4} textAlign="left">
                            <Button variant="contained" sx={{ borderRadius: "50px" }} color="primary" onClick={() => { navigate("/employer/find") }}>Find candidates ➔</Button>
                        </Box>
                    </Box>
                    <Box display="flex">
                        <Player
                        speed={0.5}
                            loop={false}
                            autoplay
                            src={hiringAnimation}
                            rendererSettings={{
                                preserveAspectRatio: 'xMidYMid meet',
                            }}
                            style={{ height: "50vh", marginTop: "16px" }}
                        />
                    </Box>
                </Box>

            </Container>
        </Box>
        <Box pt={4} pb={6} display={{ xs: "block", md: "none", background: "white" }}>
            <Container maxWidth="xl" >
                <Typography align="center" width={"100%"} fontWeight={700} fontFamily="Source Sans Pro" fontSize={{ xs: "1.8rem", md: "2.2rem" }} mb={2}>
                    Recruit smarter and faster.
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "center" }} mb={2}>
                    <Typography fontSize={{ xs: "1rem", md: "1.5rem" }} fontWeight={500} color="#20264a" >Our solution is a</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }} mb={3}>

                    <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="greenyellow">
                        <Check color='inherit' />
                        <Typography fontSize={{ xs: "0.875rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Smart</Typography>
                    </Box>
                    <Box sx={{ mr: 2, display: "flex", alignItems: "center" }} color="#46edffff">
                        <Check color='inherit' />
                        <Typography fontSize={{ xs: "0.875rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Easy</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }} color="orange">
                        <Check color='inherit' />
                        <Typography fontSize={{ xs: "0.875rem", md: "1.5rem" }} fontWeight={500} color="#20264a" ml={1}>Time Saving</Typography>
                    </Box>

                </Box>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    platform designed to <strong>match</strong> Hig Tech
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    job seekers and employers
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} mt={1}>
                    based on details that are
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    collected from both parties
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} mt={1}>
                    in order to make the most reliable
                </Typography>
                <Typography align="center" width={"100%"} fontWeight={400} fontSize={{ xs: "1.1rem", md: "1.5rem" }} >
                    and <strong>accurate</strong> match.
                </Typography>

                <Box mt={4} textAlign="center">
                    <Button variant="contained" sx={{ borderRadius: "50px" }} color="primary" onClick={() => { navigate("/employer/find") }}>Find candidates ➔</Button>
                </Box>
            </Container>
        </Box>
        <Box pt={5} pb={8} sx={{backgroundColor:"#eaf5ff"}}>
            <Container maxWidth={isUpMD ? "lg" : "sm"} >
                <Typography align="center" width={"100%"} fontWeight={400} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.2rem" }} mb={2}>
                    How it works?
                </Typography>
                <Container maxWidth={isUpMD ? "md" : "sm"}>
                    <Typography align="center" width={"100%"} fontWeight={400} color="primary" fontSize={{ xs: "1.15rem", md: "1.5rem" }} mb={2}>
                        Employers define job parameters to search by.
                    </Typography>
                    <Typography align="center" width={"100%"} fontWeight={400} color="primary" fontSize={{ xs: "1.15rem", md: "1.5rem" }} >
                        Our algorithm filters the most relevant candidates by analyzing
                    </Typography>
                    <Typography align="center" width={"100%"} fontWeight={400} color="primary" fontSize={{ xs: "1.15rem", md: "1.5rem" }} mb={6}>
                        their profile information
                    </Typography>
                </Container>
                <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center" fontSize='1.1rem' fontWeight='bold'>
                    <Box display="flex" width={{ xs: "110px", md: "120px" }} height={{ xs: "90px", md: "100px" }} flexDirection="column" justifyContent="center" alignItems="center" p={2.5} borderRadius="4px" sx={{ background: "white", color: "#1e90ff", textAlign: "center" }}>
                        <Person sx={{ mb: 1 }} />Personal Details
                    </Box>
                    <Box display="flex" width={{ xs: "110px", md: "120px" }} height={{ xs: "90px", md: "100px" }} flexDirection="column" justifyContent="center" alignItems="center" p={2.5} borderRadius="4px" sx={{ background: "white", color: "#2cab9f",textAlign: "center" }}>
                        <School sx={{ mb: 1 }} />Education
                    </Box>
                    <Box display="flex" width={{ xs: "110px", md: "120px" }} height={{ xs: "90px", md: "100px" }} flexDirection="column" justifyContent="center" alignItems="center" p={2.5} borderRadius="4px" sx={{ background: "white", color: "#d96969", textAlign: "center" }}>
                        <Work sx={{ mb: 1 }} />Experience
                    </Box>
                    <Box display="flex" width={{ xs: "110px", md: "120px" }} height={{ xs: "90px", md: "100px" }} flexDirection="column" justifyContent="center" alignItems="center" p={2.5} borderRadius="4px" sx={{ background: "white", color: "#3858ba", textAlign: "center",  }}>
                        <LinkedIn sx={{ mb: 1 }} />Social Accounts
                    </Box>
                    <Box display="flex" width={{ xs: "110px", md: "120px" }} height={{ xs: "90px", md: "100px" }} flexDirection="column" justifyContent="center" alignItems="center" p={2.5} borderRadius="4px" sx={{ background: "white", color: "#3e3939", textAlign: "center" }}>
                        <ThumbUp sx={{ mb: 1 }} />Recommenders
                    </Box>
                    <Box display="flex" width={{ xs: "110px", md: "120px" }} height={{ xs: "90px", md: "100px" }} flexDirection="column" justifyContent="center" alignItems="center" p={2.5} borderRadius="4px" sx={{ background: "white", color: "#df7208", textAlign: "center" }}>
                        <DeveloperMode sx={{ mb: 1 }} />Skills
                    </Box>
                </Box>
                <Box justifyContent="center" display="flex" mt={6}>
                    <Button variant="outlined" sx={{ borderRadius: "50px" }} color="primary" onClick={() => { navigate("/employer/find") }}>GET STARTED</Button>
                </Box>
            </Container>
        </Box>
        <Box pt={5} pb={8} sx={{ background: "#084c9d", color: "white" }}>
            <Container maxWidth="lg" >
                <Typography align="center" width={"100%"} fontWeight={400} fontFamily="Source Sans Pro" fontSize={{ xs: "1.5rem", md: "2.2rem" }} mb={3}>
                    Time Saving Process
                </Typography>
                <Box display="flex" justifyContent="space-between" flexWrap={{ xs: "wrap", md: "initial" }} mt={6} gap={2}>
                    <Box mb={2}>
                        <Typography fontSize={{ xs: "1.5rem", md: "2.2rem" }} fontWeight={700} color="#e7ffdd" mb={1}>Our Solution</Typography>
                        <Stack spacing={2} >
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>No job publishing
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>
                                    Candidates information is accurate 
                                    {/* <Typography component={isUpMD ? "div" : "div"} fontSize="inherit" fontWeight="inherit"> and approved </Typography> */}
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>
                                    Irrelevant candidates are filtered out
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "greenyellow" }}>
                                <TaskAlt color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#e7ffdd" fontWeight={500}>
                                    Full candidates profiles including
                                    <Typography component={isUpMD ? "div" : "span"} fontSize="inherit" fontWeight="inherit"> social accounts and recommenders info</Typography>
                                </Typography>

                            </ListItem>
                        </Stack>
                    </Box>
                    <Box mb={2}>
                        <Typography fontSize={{ xs: "1.5rem", md: "2.2rem" }} fontWeight={700} color="#ffebdd" mb={1}>No more</Typography>
                        <Stack spacing={2} >
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>Tiring to define job offers
                                    {/* <Typography fontSize="inherit" fontWeight="inherit" component={isUpMD ? "div" : "span"}> not always look the best</Typography> */}
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>
                                    Wasting time and effort confirming
                                    <Typography component={isUpMD ? "div" : "span"} fontSize="inherit" fontWeight="inherit"> candidates information</Typography>
                                </Typography>
                            </ListItem>
                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>
                                    Wasting time scanning tens of candidates CVs,
                                    <Typography component={isUpMD ? "div" : "span"} fontSize="inherit" fontWeight="inherit"> without knowing what is relevant</Typography>
                                </Typography>
                            </ListItem>

                            <ListItem disableGutters sx={{ color: "#ff754c" }}>
                                <Close color="inherit" />
                                <Typography fontSize={{ xs: "1rem", md: "1.3rem" }} ml={1} color="#ffebdd" fontWeight={500}>Breaking your head to get a full overview of a candidate</Typography>
                            </ListItem>
                        </Stack>
                    </Box>
                </Box>
            </Container>
        </Box>
        {/* Footer */}
        <Box sx={{
            minHeight: "20vh",
            backgroundColor: "#20264a",
            py: 5
        }}>
            <Container maxWidth="xl">
                <List >
                    {pages.map(page => <ListItem disableGutters key={page.name} >
                        <Link to={page.url} color="white" style={{ textDecoration: "none" }}>
                            <Typography color="lightgray" sx={{ textDecoration: "none" }}>{page.name}</Typography>

                        </Link>
                    </ListItem>)}
                    <ListItem disableGutters>
                        <Typography color="lightgray" sx={{ textDecoration: "none" }}>
                            Contact us at <u><a style={{ color: "lightgray" }} href="mailto:tik.tech.job@gmail.com">tik.tech.job@gmail.com</a></u>
                        </Typography>
                    </ListItem>
                </List>
            </Container>
        </Box>
    </Box>
}


export default EmployerIntro;

